export const siteName = "继母与继姐·人物图鉴";

export interface Character {
  id: string;
  name: string;
  role: string;
  tagline: string;
  summary: string;
  image: string;
  color: string;
  keyFacts: string[];
  personality: string;
  growth: string[];
}

export const characters: Character[] = [
  {
    id: "protagonist",
    name: "林晓禾",
    role: "主角",
    tagline: "在重组家庭里学着重新定义「家人」",
    summary:
      "因父亲再婚而进入全新家庭的主角，面对陌生的继母与继姐，在误解、试探与一次次坦诚中，逐渐找到属于自己的位置与归属。",
    image:
      "https://readdy.ai/api/search-image?query=Warm%20manhwa%20style%20portrait%20of%20a%20gentle%20young%20asian%20woman%20with%20soft%20shoulder%20length%20dark%20hair%2C%20wearing%20a%20cream%20knit%20sweater%2C%20mild%20melancholic%20yet%20warm%20expression%2C%20soft%20cream%20beige%20background%2C%20delicate%20lineart%2C%20editorial%20illustration%2C%20warm%20golden%20lighting%2C%20high%20detail%2C%20cozy%20atmosphere&width=640&height=640&seq=char-protagonist&orientation=squarish",
    color: "primary",
    keyFacts: ["性格：温柔内敛、慢热细腻", "身份：父亲再婚后的新家庭成员", "关键词：接纳、成长、归属感"],
    personality:
      "她外表安静，习惯把情绪藏在心里，面对新家庭时既想靠近又害怕受伤。随着故事推进，她的坦诚与坚韧逐渐成为维系这段新关系的关键。",
    growth: [
      "从试探性相处，到愿意敞开心扉表达真实想法",
      "在继母与继姐的互动中学会放下预设、重新理解家人",
      "在一次次冲突与和解里，成长为更自信、更柔软的人",
    ],
  },
  {
    id: "stepmother",
    name: "苏蔓",
    role: "继母角色",
    tagline: "温柔与克制之下，藏着不被看见的用心",
    summary:
      "作为继母角色，苏蔓温柔却克制，努力在新家庭中寻找平衡。她的每一次退让与坚持，都源于对这段关系最朴素的珍视。",
    image:
      "https://readdy.ai/api/search-image?query=Warm%20manhwa%20style%20portrait%20of%20an%20elegant%20mature%20asian%20woman%20in%20her%20forties%2C%20soft%20low%20bun%20hair%2C%20gentle%20knowing%20smile%2C%20wearing%20a%20beige%20blouse%2C%20warm%20terra%20cotta%20background%2C%20soft%20cinematic%20lighting%2C%20refined%20editorial%20illustration%2C%20motherly%20yet%20composed%2C%20high%20detail&width=640&height=640&seq=char-stepmother&orientation=squarish",
    color: "accent",
    keyFacts: ["性格：温柔克制、细腻周全", "身份：主角父亲的再婚妻子", "关键词：耐心、分寸、守护"],
    personality:
      "她成熟得体，懂得留白与分寸，从不越界表达善意。正因如此，她与主角之间的每一次靠近都格外珍贵，也格外缓慢。",
    growth: [
      "从小心翼翼地维持体面，到学会直接表达关心",
      "在处理女儿与继女之间的关系时不断调整自己的方式",
      "最终用自己的方式，成为这个家庭真正的「黏合剂」",
    ],
  },
  {
    id: "stepsister",
    name: "苏念雪",
    role: "继姐角色",
    tagline: "外冷内热，是刺猬也是暖光",
    summary:
      "作为继姐角色，苏念雪外冷内热，习惯用距离感保护自己。她与主角从针锋相对到彼此理解，是关系网中最具戏剧张力的一条线。",
    image:
      "https://readdy.ai/api/search-image?query=Warm%20manhwa%20style%20portrait%20of%20a%20stylish%20young%20asian%20woman%20with%20long%20straight%20hair%2C%20cool%20slightly%20guarded%20expression%2C%20wearing%20a%20dark%20olive%20jacket%2C%20soft%20warm%20cream%20and%20sage%20background%2C%20editorial%20illustration%2C%20cinematic%20warm%20lighting%2C%20high%20detail%2C%20contemporary%20manhwa%20style&width=640&height=640&seq=char-stepsister&orientation=squarish",
    color: "secondary",
    keyFacts: ["性格：外冷内热、口是心非", "身份：继母带来的女儿", "关键词：逞强、破冰、理解"],
    personality:
      "她看似强势冷静，其实比谁都渴望被理解。那些带刺的话语背后，是一次次笨拙的试探与保护。",
    growth: [
      "从处处针锋相对，到悄悄观察、偷偷在意",
      "在与主角的一次次交锋中卸下防备",
      "最终学会用最坦率的方式表达在意与珍视",
    ],
  },
];

export interface Relationship {
  pair: string;
  tone: string;
  title: string;
  description: string;
  status: string;
}

export const relationships: Relationship[] = [
  {
    pair: "主角 × 继母",
    tone: "渐进式信任",
    title: "从客套到真心",
    description:
      "起初两人都保持礼貌的距离，继母处处留分寸，主角则默默观察。随着共同经历家庭事务与琐碎日常，她们终于从「客气」走向「贴心」。",
    status: "逐渐建立信任",
  },
  {
    pair: "主角 × 继姐",
    tone: "破冰式和解",
    title: "从对峙到守望",
    description:
      "这是全篇最具张力的关系。两人因性格差异与误会反复碰撞，又在每一次争吵后更靠近对方，最终成为彼此最坚实的陪伴。",
    status: "逐步走向和解",
  },
  {
    pair: "继母 × 继姐",
    tone: "母女式依偎",
    title: "熟悉却需要重新连接",
    description:
      "母女之间既有天然默契，也有各自不愿言说的顾虑。继母为女儿骄傲又心疼，继姐则把对母亲的依赖藏在倔强里。",
    status: "互相理解加深",
  },
];

export interface FaqItem {
  q: string;
  a: string;
}

export const faqs: FaqItem[] = [
  {
    q: "《继母与继姐》的主角是谁？",
    a: "主角是林晓禾，一个因父亲再婚而进入全新家庭的年轻女孩。她在陌生环境里从小心翼翼，逐渐学会接纳新家人，也重新定义了自己的归属感。",
  },
  {
    q: "继母角色在故事中处于怎样的位置？",
    a: "继母苏蔓是父亲再婚后的妻子，也是连接整个家庭的关键人物。她温柔克制，懂得留白与分寸，用自己的耐心成为这个重组家庭真正的黏合剂。",
  },
  {
    q: "继姐角色和主角是什么关系？",
    a: "继姐苏念雪是继母带来的女儿，与主角并没有血缘关系，却在朝夕相处中成为最亲密的陪伴。两人的关系从针锋相对到彼此理解，是全篇最具看点的情感线。",
  },
  {
    q: "「继母与继姐」的人物关系是怎样的？",
    a: "核心三角是主角、继母与继姐：主角与继母从客套走向信任，主角与继姐从对峙走向守望，继母与继姐则是母女式依偎。三者互相牵动，共同构成完整的家庭关系网。",
  },
  {
    q: "主角与继姐的关系走向是怎样的？",
    a: "两人因性格差异反复碰撞，又在争吵中逐渐读懂彼此。这段关系并非一蹴而就的和解，而是在一次次试探、误会与坦诚中，慢慢长出真正的信任与默契。",
  },
];